<template>
  <div class="page">
    <Header
        :title=pageTitle
        :filter=pageFilter
        :total=pageTotal
    />
    <div v-show="isDataVisible" class="container dashboard card">
      <div class="card-header">
        <span class="other-buttons">
          <button @click="downloadTable()" class="btn btn-primary">
            <i class="fa fa-download"></i>
          </button>
        </span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsToDeploySelectedCount === 0 }"
              title="Please select VMs with Action Created to deploy">
          <button @click="deploy()"
                  :class="['btn btn-default run-btn ' + DeployVM.status, { 'disabled': itemsToDeploySelectedCount === 0 }]">Deploy VM</button>
        </span>
        <span class="other-buttons">
          <button @click="$modal.show('VmNewNode')" class="btn btn-primary">New VM</button>
        </span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsSelectedCount === 0 }"
              title="Please select VMs to delete">
        <button class="btn btn-default delete-btn small icon-only"
                @click="openDeleteItemsConfirmation()"
                :class="['btn btn-danger', { 'disabled': itemsSelectedCount === 0 }]">
          Delete <span v-if="itemsSelectedCount <= 1">VM</span><span v-else>VMs</span>  <i class="fa fa-trash"></i>
        </button>
        </span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsSelectedCount === 0 }"
              title="Please select VMs to start">
          <button class="btn btn-default small icon-only"
                  @click="startList()"
                  :class="['btn btn-default run-btn ', { 'disabled': itemsSelectedCount === 0 }]">
            Run <span v-if="itemsSelectedCount <= 1">VM</span><span v-else>VMs</span>  <i class="fa fa-play"></i>
          </button>
        </span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsSelectedCount === 0 }"
              title="Please select VMs to start">
          <button class="btn btn-default small icon-only"
                  @click="stopList()"
                  :class="['btn btn-default run-btn ', { 'disabled': itemsSelectedCount === 0 }]">
            Stop <span v-if="itemsSelectedCount <= 1">VM</span><span v-else>VMs</span>  <i class="fa fa-stop"></i>
          </button>
        </span>
      </div>
      <div class="card-body">
        <div class="alert alert-info alert-dismissable" v-show="info != ''">
          <strong>
            <b-icon icon="info-circle-fill"></b-icon>
          </strong>
          <div class="alert-text" style="display: inline-block;"> {{ info }}</div>
        </div>
        <div v-bind:class="loading"></div>
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr>
            <th scope="col">
              <div class="flex">
                <span class="col-text" @click="SortInvert('Id')">Id</span>
                <span class="icon-up" v-show="sortField === 'Id'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-Id'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" style="width: 3rem;" @click="SortInvert('State')">State 🚦</span>
                <span class="icon-up" v-show="sortField === 'State'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-State'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" @click="SortInvert('Name')">Name 🔡</span>
                <span class="icon-up" v-show="sortField === 'Name'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-Name'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" style="width: 3rem;"  @click="SortInvert('Type')">Type 📃</span>
                <span class="icon-up" v-show="sortField === 'Type'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-Type'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col" style="width: 15rem">
              <div class="flex">
                <span class="col-text" @click="SortInvert('Server')">Server 🗄</span>
                <span class="icon-up" v-show="sortField === 'Server'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-Server'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" @click="SortInvert('IP')">IP ɪᴘ</span>
                <span class="icon-up" v-show="sortField === 'IP'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-IP'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" @click="SortInvert('MAC')">MAC</span>
                <span class="icon-up" v-show="sortField === 'MAC'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-MAC'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" style="width: 3rem;"  @click="SortInvert('RAM')">RAM 🟰</span>
                <span class="icon-up" v-show="sortField === 'RAM'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-RAM'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" style="width: 3rem;"  @click="SortInvert('RAM')">CPU 🔋</span>
                <span class="icon-up" v-show="sortField === 'RAM'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-RAM'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col">
              <div class="flex">
                <span class="col-text" @click="SortInvert('RAM')">Discovered 💡</span>
                <span class="icon-up" v-show="sortField === 'RAM'"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span class="icon-down" v-show="sortField ==='-RAM'"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th/>
            <th scope="col" class="text-center">
              <b-checkbox
                  @change="selectAll()"
                  v-model="allSelected"
              ></b-checkbox>
            </th>
          </tr>
          <VmFilters
              :itemsSelectedCount="itemsSelectedCount"
              @onChanged="filterChanged"
              @changeTitle="changeTitle"
              title="VMs"
              v-on:onChanged="filterChanged"
              v-on:onInit="filterInit"
              :filter="filterOptions"
              :filterValues="filterValues"
              :filterExact="filterExact"
              :columns="columns"
              @deleteItems="openDeleteItemsConfirmation"
          />
          </thead>
          <tbody v-if="items !== null && items.length > 0">
          <tr
              v-for="item in items"
              v-bind:key="item.id"
              @click="rowClick(item, $event)"
              :data-item-id="item.Id"
              :id="'item' + item.Id"
              :class="{'selected':selectedItemsList.indexOf(item.Id) >= 0}"
          >
            <td><span class="cel-text">{{ item['Id'] }}</span></td>
            <td>
               <span class="cel-text" style="all: initial;">
                <span v-if="item['State'] === 'poweredOn'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">🟢</span>
                <span v-else-if="item['State'] === 'poweredOff'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">🔴</span>
                <span v-else-if="item['State'] === ''" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">0️⃣</span>
                <span v-else-if="item['State'] === 'UNKNOWN'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">🤷</span>
                <span v-else-if="item['State'] === 'DESTROYED'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">🚫 </span>
                <span v-else-if="item['State'] === 'NONE'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">⭕️ </span>
                <span v-else-if="item['State'] === 'suspended'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">⏸️</span>
                <span v-else-if="item['State'] === 'CREATED'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">🚀</span>
                <span v-else-if="item['State'] === 'CHANGED'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">⚠️</span>
                <span v-else-if="item['State'] === 'DELETED'" v-tippy="{arrow : true}"
                      :title="`State: ${item['State']}`">🗑️</span>
                <span v-else-if="item['State'] === 'ERROR'" v-tippy="{arrow : true}" title="Not found">❌</span>
                <span v-if="item['Action'] === 'CHANGED'" v-tippy="{arrow : true}"
                      :title="'Action:' + item['Action']">⚠️</span>
                <span v-else-if="item['Action'] === 'MOVE_PENDING'" v-tippy="{arrow : true}"
                      :title="'Action:' + item['Action']">🔜</span>
              </span>
            </td>
            <td><span class="cel-text">
              <span class='vm-field-name'>{{ item['Name'] }}</span>
              <span class='vm-field-iso-icon' v-show="item['VmIso']" v-tippy="{arrow : true}" :title="item['VmIso']">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M20 424.2h20V279.8H20c-11 0-20-9-20-20V212c0-11 9-20 20-20h112c11 0 20 9 20 20v212.2h20c11 0 20 9 20 20V492c0 11-9 20-20 20H20c-11 0-20-9-20-20v-47.8c0-11 9-20 20-20zM96 0C56.2 0 24 32.2 24 72s32.2 72 72 72 72-32.2 72-72S135.8 0 96 0z"/></svg>
              </span>
              <br><span class='vm-field-comment' v-tippy="{arrow : true, interactive: true}"
                        :title="item['Comment']">{{ item['Comment'] }}</span>
              </span>
            </td>
            <td class="text-center">
              <span class="cel-text">
                <span
                    v-if="typeList[item['Entity']]?.toLowerCase() === 'managed'"
                    v-tippy="{arrow : true}"
                    title="managed"
                >🛂</span>
                <span
                    v-else-if="typeList[item['Entity']]?.toLowerCase() === 'diskless'"
                    v-tippy="{arrow : true}"
                    title="diskless"
                >⚡️</span>
                <span
                    v-else-if="typeList[item['Entity']]?.toLowerCase() === 'default'"
                    v-tippy="{arrow : true}"
                    title="default"
                >🟨</span>
              </span>
            </td>
            <td>
               <span class="cel-text">
                <span v-tippy="{arrow : true}" :title="`Server status: ${item['ServerState']}`">
                      <span v-if="item['ServerState'] === 'OK'">🟢</span>
                      <span v-else-if="item['ServerState'] === 'NO PING'">🔴</span>
                      <span v-else-if="item['ServerState'] === '' || item['ServerState'] == null">0️⃣️</span>
                  [<a :href="`https://${item['ServerIp']}`" target="_blank">{{ item['ServerIp'] }}</a>
                   <span class="copy-click" @click="(event) => copyText(item.ServerIp, event)">
                    <span class="text-for-copy">&nbsp;</span>
                    <i class="fa fa-copy"></i><i class="fa fa-check"></i><i class="fa fa-ban"></i>
                   </span>&nbsp;]
                  <a style="color: #000441; cursor: pointer; font-weight: 500;"
                          :href='`/#/server/list?page=1&filter=[{"Condition":"=","Data":{"Id":${item.ServerId}}}]`'>{{
                    item['Server']
                  }}</a>
                </span>
              </span>
            </td>
            <td>
                <span class="cel-text">
                 <span v-if="item['IpState'] == 'OK'" v-tippy="{arrow : true}"
                       title="Ip is pinging">🟢
                   <span class="copy-click" @click="(event) => copyText(item.Ip, event)">
                    <span class="text-for-copy">{{ item.Ip }}</span>
                    <i class="fa fa-copy"></i><i class="fa fa-check"></i><i class="fa fa-ban"></i>
                   </span>
                 </span>
                <span v-else v-tippy="{arrow : true}" title="Ip does not ping">🔴
                   <span class="copy-click" @click="(event) => copyText(item.Ip, event)">
                    <span class="text-for-copy">{{ item.Ip }}</span>
                    <i class="fa fa-copy"></i><i class="fa fa-check"></i><i class="fa fa-ban"></i>
                   </span></span>
              </span>
            </td>
            <td><span class="cel-text">{{ item['Mac'] }}</span></td>
            <td><span class="cel-text">{{ item['Ram'] }}</span></td>
            <td><span class="cel-text">{{ item['Cpu'] }}</span></td>
            <td><span class="cel-text">{{ item['DiscoveredAt'] }}</span></td>

            <td>
              <span class="cel-buttons" style="display: flex">
                <button @click="startVm(item.Id)" class="btn btn-as-link icon-only  text-success">
                  <i class="fa fa-play"></i>
                </button>
                <button @click="stopVm(item.Id)" class="btn btn-as-link icon-only  text-danger">
                  <i class="fa fa-stop"></i>
                </button>
                <button class="btn btn-as-link icon-only" @click="refreshVm(item)">
                    <i class="fa fa-refresh"></i>
                  </button>
                <button class="btn btn-as-link icon-only" @click="editItem(item)">
                  <i class="fa fa-pencil"></i>
                </button>
                <button class="btn btn-as-link icon-only text-danger" @click="openDeleteItemConfirmation(item)">
                  <i class="fa fa-trash"></i>
                </button>
                <button class="btn btn-as-link icon-only text-info" @click="cloneItem(item)">
                  <i class="fa fa-clone"></i>
                </button>
              </span>
            </td>
            <!--            <span v-if="column.name == 'Links'" class="cel-buttons">-->
            <!--                <button v-for="link in column.links" v-bind:key="link.value" class="btn btn-default icon-only"-->
            <!--                        @click="linkItem(link.url,item)">-->
            <!--                  <img v-if="link.icon.type=='bitmap'" :title="link.text" class="item-icon"-->
            <!--                       :src="`/img/${link.icon.value}`">-->
            <!--                  <b-icon v-if="link.icon.type=='vector'" :icon="link.icon.value"></b-icon>-->
            <!--                  <i v-if="link.icon.type=='fa'" :class="link.icon.value"></i>-->
            <!--                </button>-->
            <!--            </span>-->
            <td class="text-center">
              <b-checkbox
                  v-model="selectedItemsList"
                  :value="item.Id"
              ></b-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="items.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :options="[
                {value: '10',text: '10'},
                {value: '50',text: '50'},
                {value: '100',text: '100'},
                {value: '500',text: '500'},
                {value: '1000',text: '1000'},
            ]"
        />
      </div>
    </div>

    <VmNewNode
        successCreateCallback="loadData()"
        :DcId="DcIdForNewItem"
        :ServerId="ServerIdForNewItem"
        :ServerName="ServerNameForNewItem"
        :cloneItem="itemForClone"
        @loadData="LoadData"
    />
    <EditVm @closed="() => currentItem = null" :types="typeList" :currentItem="currentItem"/>
    <ModalConfirmVmDeploy v-on:onConfirm="runDeployCreatedNodes"/>

    <!--    <ModalItem-->
    <!--        type="edit"-->
    <!--        :itemId="currentItemId"-->
    <!--        :item=currentItem-->
    <!--        title="Edit VM: "-->
    <!--        update-title-key="Name"-->
    <!--        :height="810"-->
    <!--        :modalName="'editItem'"-->
    <!--        v-on:onSuccess="itemSuccess"/>-->

    <ModalConfirmItemDelete
        v-on:onComplete="deletedItem"
        v-on:onError="deletedItemErr"
        :url="apiUrl"
        :itemId="currentItemId"
    />

    <ModalLog :data="textareaData" :modalName="'modalTextarea'"/>

    <ModalError name="listError" :message="error"/>

    <ModalSuccess name="listSuccess" :message="success"/>

    <ModalItemInfo
        type="edit"
        :itemId=currentItemIdForInfo
        :item=currentItemForInfo
        v-on:onSuccess="itemSuccess"/>
    <ModalConfirm
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        :buttons="confirmButtons"
        :form="modalConfirmForm"
        v-on:onModalСonfirmEvent="confirmEvent"/>
    <DeleteDestroyVm :items="items" :selectedItemsList="selectedItemsList" @delete="deleteItems"
                     @destroy="destroyItems"/>
  </div>
</template>
<script>
import axios from 'axios';

// mixins
import {UserStoredDataMixin} from '@/assets/js/mixins/user-stored-data-mixin';
import {ListLogicMixin} from '@/assets/js/mixins/list-logic-mixin';
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import VmNewNode from "../VmNewNode.vue";
import ModalConfirmVmDeploy from "../ModalConfirmVmDeploy.vue";
import ModalItemInfo from "../ModalItemInfo.vue";
import _ from "lodash";
import VmFilters from "@/components/filters/VmFilters.vue";
import DeleteDestroyVm from "@/components/modal/DeleteDestroyVm.vue";
import EditVm from "@/components/modal/EditVm.vue";
import {EventBus} from "@/eventBus";

export default {
  name: 'listPage',
  mixins: [
    TokenMixin,
    UserStoredDataMixin,
    ListLogicMixin
  ],
  components: {
    EditVm,
    DeleteDestroyVm,
    VmFilters,
    ModalConfirmVmDeploy,
    VmNewNode,
    ModalItemInfo,
  },
  data() {
    return {
      pageTitle: 'VMs',
      pageFilter: '',
      pageTotal: '',
      total: 0,
      title: 'VMs',
      deleteModalTitle: '',
      queryFilter: [],
      allSelected: false,
      items: [],
      itemsSelectedCount: 0,
      currentItemId: -1,
      currentItemIdForDelete: -1,
      currentItemNameForDelete: '',
      currentItem: {},
      apiVmStart: '/api/manager/vm/start/',
      apiVmStop: '/api/manager/vm/stop/',
      apiGetVm: '/api/manager/vm/',
      apiVmStatus: '/api/manager/vm/status/',
      apiList: '/api/manager/vm/list',
      apiTypeList: '/api/manager/vm-entities',
      apiItem: '',
      apiUrl: '/api/manager/vm/',
      apiConfig: '/api/config/list',
      typeList: [],
      columns: [
        {name: 'Id', value: 'Id'},
        {name: 'Server', value: 'Server'},
        {name: 'Prev. server', value: 'Prev. server'},
        {name: 'Name', value: 'Name'},
        {name: 'Ip', value: 'Ip'},
        {name: 'State', value: 'State'},
        {name: 'Mac', value: 'Mac'},
        {name: 'Ram', value: 'Ram'},
        {name: 'Cpu', value: 'Cpu'},
        {name: 'Comment', value: 'Comment'},
        {name: 'ProjectId', value: 'ProjectId'},
        {name: 'DiscoveredAt', value: 'DiscoveredAt'},
        {name: 'CRUD', value: 'CRUD'},
      ],
      options: [],
      DiscoverVM: {
        api: "/api/launcher/start",
        apiStatus: "/api/launcher/status",
        status: "",
        name: "DiscoverVM",
        timer: true,
      },
      DeployVM: {
        api: "/api/manager/vm/deploy/?custom=y",
        apiStatus: "/api/launcher/status",
        status: "",
        name: "deployVm",
        timer: true,
      },
      DeleteVM: {
        api: "/api/manager/vm/list/delete",
        apiStatus: "/api/launcher/status",
        status: "",
        name: "deleteVm",
        timer: true,
      },
      DestroyVM: {
        api: "/api/manager/vm/list/destroy",
        apiStatus: "/api/launcher/status",
        status: "",
        name: "destroyVm",
        timer: true,
      },
      StartVMs: {
        api: "/api/manager/vm/list/start",
        apiStatus: "/api/launcher/status",
        status: "",
        name: "startVm",
        timer: true,
      },
      StopVMs: {
        api: "/api/manager/vm/list/stop",
        apiStatus: "/api/launcher/status",
        status: "",
        name: "stopVm",
        timer: true,
      },
      textareaData: '',
      currentItemIdForInfo: 0,
      currentItemForInfo: {},
      confirmButtons: [],
      confirmDeleteButtons: [
        {
          "name": "delete",
          "text": "Yes, delete",
          "class": "primary"
        },
        {
          "name": "cancel",
          "text": "Cancel"
        }
      ],
      confirmDeleteOrDestroyButtons: [
        {
          "name": "delete",
          "text": "Delete from db",
          "class": "primary"
        },
        {
          "name": "destroy",
          "text": "DESTROY and remove vm data",
          "class": "destroy"
        },
        {
          "name": "cancel",
          "text": "Cancel"
        }
      ],
      confirmEvent: function () {
      },
      confirmModalItemTitle: 'Confirm delete or destroy items',
      confirmModalItemMsg: 'What do you want to do?',
      DcIdForNewItem: 0,
      ServerIdForNewItem: 0,
      ServerNameForNewItem: 0,
      itemForClone: {},
      confirmModalDeployTitle: 'Confirm VM deploy',
      confirmModalDeployMsg: 'Are you sure you want to deploy VM?',
      confirmDeployButtons: [
        {
          "name": "deploy",
          "text": "Deploy",
          "class": "primary"
        },
        {
          "name": "cancel",
          "text": "Cancel"
        }
      ],
      confirmModalStartTitle: 'Confirm VMs start',
      confirmModalStartMsg: 'Are you sure you want to start VMs?',
      confirmStartButtons: [
        {
          "name": "start",
          "text": "Start",
          "class": "primary"
        },
        {
          "name": "cancel",
          "text": "Cancel"
        }
      ],
      confirmModalStopTitle: 'Confirm VMs stop',
      confirmModalStopMsg: 'Are you sure you want to stop VMs?',
      confirmStopButtons: [
        {
          "name": "stop",
          "text": "Stop",
          "class": "primary"
        },
        {
          "name": "cancel",
          "text": "Cancel"
        }
      ],
      modalConfirmForm: [],
      modalDefaultForm: [],
      selectedItemsToDeployList: [],
      filterOptions: [
        {
          name: "Entity",
          uri: "/api/manager/vm-entities",
          method: "get",
          options: [{value: "", label: "ANY Type"}]
        },
        {
          name: "State",
          uri: "/api/manager/vm/flat?group=State",
          labelField: "State",
          valueField: "State",
          options: [{value: "", label: "ANY"}]
        }
      ],
      filterValues: {
        "State":"",
        "Entity":"",
      },
    };
  },
  methods: {
    changeTitle(title) {
      this.title = title;
    },
    refreshVm(item) {
      if (item.State === "poweredOn" && !_.isEmpty(item.Ip)) {
        if (item.IpState === "OK") {
          this.refresh(item.Ip);
        } else {
          this.refresh(item.ServerIp);
        }
      } else {
        if (!_.isEmpty(item.ServerIp)) {
          this.refresh(item.ServerIp);
        } else {
          this.NotifyWarning(`Try VM state update failed`, "Empty IP values");
        }
      }
    },
    selectAll: function () {
      this.selectedItemsList = [];
      if (this.allSelected) {
        let index;
        for (index in this.items) {
          this.selectedItemsList.push(this.items[index].Id);
          this.itemsSelectedCount++
        }
      }
    },
    checkDiscoverStatus() {
      if (this.DiscoverVM.status === "running") {
        axios.post(this.DiscoverVM.apiStatus,
            {
              name: this.DiscoverVM.name
            },
            this.authRespConf())
            .catch((err) => {
              this.DiscoverVM.status = '';
              this.errorHandle(err, true, true);
            })
            .then(res => {
              if (res !== null && res !== undefined) {
                if (res.data != "") {
                  if (res.data.data !== "processed") {
                    this.DiscoverVM.status = "";

                    this.getAndShowDiscoverLogs();
                    this.LoadData();
                    this.success = 'Script successfully finished!';
                    this.$modal.show('success');
                  }
                  else {
                    // setTimeout(this.checkDiscoverStatus, 2000);
                  }
                }
              }
            });
      }
    },
    filterInit(resultFilter) {
      this.filters = resultFilter;
      for (let filterItem in this.filters) {
        if (!this.filters[filterItem]) {
          continue;
        }
        if (!this.filters[filterItem]['Data']) {
          continue;
        }
        if (this.filters[filterItem]['Data']['DcId']) {
          this.DcIdForNewItem = this.filters[filterItem]['Data']['DcId'];
          //console.log('SET DcId', this.DcIdForNewItem);
        }
        if (this.filters[filterItem]['Data']['ServerId']) {
          this.ServerIdForNewItem = this.filters[filterItem]['Data']['ServerId'];
        }
        if (this.filters[filterItem]['Data']['Server']) {
          this.ServerNameForNewItem = this.filters[filterItem]['Data']['Server'];
        }
      }
    },
    runDeployCreatedNodes() {
      //this.$modal.hide('confirmVmDeploy');
      this.error = '';
      this.DeployVM.status = 'running';
      let deployApiUrl = this.DeployVM.api;

      let filter = [];

      let data = {};
      data["id"] = this.selectedItemsToDeployList;
      filter.push({
        Condition: "in",
        Data: data,
      });
      axios.post(deployApiUrl,
          filter,
          this.authRespConf())
          .catch((err) => {
            this.errorHandle(err, true, true);
            this.DeployVM.status = '';
          })
          .then(res => {
            if (res !== null && res !== undefined) {
              //this.info = 'Running';
              //setTimeout(this.clearInfo, 5000);
              setTimeout(this.checkDeployStatus, 2000);
            }
          })
    },
    runStartNodes() {
      console.debug("runStartNodes");
      this.error = '';
      this.StartVMs.status = 'running';
      let deployApiUrl = this.StartVMs.api;

      axios.post(deployApiUrl,
          this.selectedItemsList,
          this.authRespConf())
          .catch((err) => {
            this.errorHandle(err, true, true);
            this.StartVMs.status = '';
          })
          .then(res => {
            if (res !== null && res !== undefined) {
              //this.info = 'Running';
              //setTimeout(this.clearInfo, 5000);
              setTimeout(this.checkDeployStatus, 2000);
            }
          })
    },
    runStopNodes() {
      console.debug("runStopNodes");
      this.error = '';
      this.StopVMs.status = 'running';
      let deployApiUrl = this.StopVMs.api;

      axios.post(deployApiUrl,
          this.selectedItemsList,
          this.authRespConf())
          .catch((err) => {
            this.errorHandle(err, true, true);
            this.StopVMs.status = '';
          })
          .then(res => {
            if (res !== null && res !== undefined) {
              //this.info = 'Running';
              //setTimeout(this.clearInfo, 5000);
              setTimeout(this.checkDeployStatus, 2000);
            }
          })
    },
    //deprecated?
    runDestroyNodes() {
      this.ListLogicMixin.methods.LoadData();
      this.error = '';
      this.DestroyVM.status = 'running';
      let deployApiUrl = this.DestroyVM.api;
      axios.post(deployApiUrl,
          [],
          this.authRespConf())
          .catch((err) => {
            this.errorHandle(err, true, true);
            this.DestroyVM.status = '';
          })
          .then(res => {
            if (res !== null && res !== undefined) {
              setTimeout(this.checkDestroyStatus, 2000);
            }
          })
    },
    checkDeployStatus() {
      if (this.DeployVM.status === "running") {
        axios.post(this.DeployVM.apiStatus,
            {
              name: this.DeployVM.name
            },
            this.authRespConf())
            .catch((err) => {
              this.DeployVM.status = '';
              this.errorHandle(err, true, true);
            })
            .then(res => {
              if (res !== null && res !== undefined) {
                if (res.data != "") {
                  if (res.data.data !== "processed") {
                    this.DeployVM.status = "";
                    this.getAndShowLogsBy("vm-deploy");
                    this.LoadData();
                    this.success = 'Script successfully finished!';
                    this.$modal.show('VmListSuccess');
                  } else {
                    setTimeout(this.checkDeployStatus, 2000);
                  }
                }
              }
            });
      }
    },
    checkDestroyStatus() {
      if (this.DestroyVM.status === "running") {
        axios.post(this.DestroyVM.apiStatus,
            {
              name: this.DestroyVM.name
            },
            this.authRespConf())
            .catch((err) => {
              this.DestroyVM.status = '';
              this.errorHandle(err, true, true);
            })
            .then(res => {
              if (res !== null && res !== undefined) {
                if (res.data != "") {
                  if (res.data.data !== "processed") {
                    this.DestroyVM.status = "";
                    this.getAndShowLogsBy("vm-destroy");
                    this.LoadData();
                    this.success = 'Script successfully finished!';
                    this.$modal.show('VmListSuccess');
                  } else {
                    setTimeout(this.checkDestroyStatus, 2000);
                  }
                }
              }
            });
      }
    },
    cloneItem(item) {
      this.itemForClone = {...item}
      this.$modal.show('VmNewNode')
    },
    editItem(item) {
      //this.$router.push({path: this.apiItem + item.Id});
      // this.currentItemId = item.Id;
      this.currentItem = item;
      this.$modal.show('EditVm');
    },
    getAndShowDiscoverLogs() {
      let loader = this.$loading.show();
      this.loading = 'loading';
      axios.post('/api/log/list?limit=20&sort=-id&page=1',
          [{"Condition": "ilike", "Data": {"Entity": "DiscoverVM"}}],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.moveUp();
            this.loading = 'loaded';
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              let last_log = res.data.data[0];
              this.textareaData = last_log.Data;
              this.$modal.show('modalTextarea');
            } else {
              this.errorHandle(res, false, true, "Something wrong, no logs found.");
            }
          });
    },

    getAndShowLogsBy(entityName) {
      let loader = this.$loading.show();
      this.loading = 'loading';
      axios.post('/api/log/list?limit=20&sort=-id&page=1',
          [{"Condition": "ilike", "Data": {"Entity": entityName}}],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.moveUp();
            this.loading = 'loaded';
            this.errorHandle(err, true, true);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              let last_log = res.data.data[0];
              this.textareaData = last_log.Data;
              this.$modal.show('modalTextarea');
            } else {
              this.errorHandle(res, true, true, "Something wrong, no logs found.");
            }
          });
    },
    startVm(itemId) {
      let loader = this.$loading.show();
      axios.post(this.apiVmStart + itemId,{}, this.authRespConf())
          .catch((err) => {
            loader.hide();
            const error = this.errorHandle(err, true, true);
            if (error === "already ")
              this.NotifyWarning(`VM ${itemId}`, "The VM already started");
          })
          .then(res => {
            loader.hide();
            if (res) {
              if (res.status <= 204) {
                this.NotifySuccess(`VM ${itemId}`, `The VM is starting up`);
              }
            }
          });
    },
    stopVm(itemId) {
      let loader = this.$loading.show();
      axios.post(this.apiVmStop + itemId, {}, this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true);
          })
          .then(res => {
            loader.hide();
            if (res) {
              if (res.status <= 204) {
                this.NotifyDanger(`VM ${itemId}`, `The VM is shutting dow`);
              }
            }
          });
    },
    updateVmState(itemId) {
      let loader = this.$loading.show();

      axios.get(this.apiGetVm + itemId, this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true);
          })
          .then(res => {
            loader.hide();
            const vm = _.find(this.items, {Id: itemId})
            vm.Action = res.data.data.Action
            vm.State = res.data.data.State
            this.NotifyInfo(`VM ${vm.Name}`, `VM ${vm.Name} now is ${vm.State} state`);
          });
    },
    openDeleteItemsConfirmation() {
      this.$modal.show('DeleteOrDestroyVm');
    },
    openDeleteItemConfirmation(item) {
      this.selectedItemsList = [item.Id]
      this.$modal.show('DeleteOrDestroyVm');
    },

    deleteItems(deleteIp = 0) {
      let url = this.DeleteVM.api
      if (deleteIp) {
        url = `${url}?delete_ip=${deleteIp}`;
      }
      const items = this.selectedItemsList.length > 0 ? this.selectedItemsList : [this.currentItemIdForDelete]
      axios.post(url, items, this.authRespConf())
          .then(() => {
            this.unselectItemsList(items);
            this.currentItemIdForDelete = 0;
            this.LoadData();
          })
          .catch((err) => {
            this.unselectItemsList(items);
            this.currentItemIdForDelete = 0;
            this.errorHandle(err, true, true);
          });
    },
    destroyItems(items, deleteIp = 0) {
      let url = this.DestroyVM.api;
      if (deleteIp) {
        url = `${url}?delete_ip=${deleteIp}`;
      }
      // const items = this.selectedItemsList.length > 0 ? this.selectedItemsList : [this.currentItemIdForDelete]
      axios.post(url, items, this.authRespConf())
          .then(() => {
            this.unselectItemsList(items);
            this.currentItemIdForDelete = 0;
            this.LoadData();
          })
          .catch((err) => {
            this.unselectItemsList(items);
            this.currentItemIdForDelete = 0;
            this.errorHandle(err, true, true);
          });
    },
    deploy() {
      if (this.itemsToDeploySelectedCount > 0) {
        //this.$modal.show('confirmVmDeploy');
        console.log('openDeployConfirmation');
        this.confirmModalTitle = this.confirmModalDeployTitle;
        this.confirmModalMsg = this.confirmModalDeployMsg
        if (this.itemsToDeploySelectedCount <= 5) {
          const names = _.map(this.selectedItemsToDeployList, id => {
            const foundObject = _.find(this.items, {'Id': id});
            return foundObject ? foundObject.Name : null;
          });
          this.confirmModalMsg = `${this.confirmModalMsg} (${names.join(',')})`;
        } else {
          this.confirmModalMsg = `${this.confirmModalMsg} (${this.itemsToDeploySelectedCount} vms)`;
        }
        this.confirmButtons = this.confirmDeployButtons;
        this.confirmEvent = this.onDeployConfirm;
        this.$modal.show('confirm');
      } else {
        console.log('no one VM selected')
      }
    },
    onDeployConfirm(data) {
      if (!Object.keys(data).includes('button') ||
          !Object.keys(data).includes('form')) {
        console.log('confirm data excluded button and form fields');
      }
      if (data['button'] === 'deploy') {
        this.runDeployCreatedNodes();
      }
      this.selectedItemsList = [];
    },
    startList() {
      if (this.itemsSelectedCount > 0) {
        console.log('open start confirmation');
        this.confirmModalTitle = this.confirmModalStartTitle;
        this.confirmModalMsg = this.confirmModalStartMsg
        if (this.itemsSelectedCount <= 5) {
          const names = _.map(this.selectedItemsList, id => {
            const foundObject = _.find(this.items, {'Id': id});
            return foundObject ? foundObject.Name : null;
          });
          this.confirmModalMsg = `${this.confirmModalMsg} (${names.join(',')})`;
        } else {
          this.confirmModalMsg = `${this.confirmModalMsg} (${this.itemsSelectedCount} vms)`;
        }
        this.confirmButtons = this.confirmStartButtons;
        this.confirmEvent = this.onStartConfirm;
        this.$modal.show('confirm');
      } else {
        console.log('no one VM selected')
      }
    },
    onStartConfirm(data) {
      if (!Object.keys(data).includes('button') ||
          !Object.keys(data).includes('form')) {
        console.log('confirm data excluded button and form fields');
      }
      if (data['button'] === 'start') {
        this.runStartNodes();
      }
      this.selectedItemsList = [];
    },
    stopList() {
      if (this.itemsSelectedCount > 0) {
        console.log('open start confirmation');
        this.confirmModalTitle = this.confirmModalStopTitle;
        this.confirmModalMsg = this.confirmModalStopMsg
        if (this.itemsSelectedCount <= 5) {
          const names = _.map(this.selectedItemsList, id => {
            const foundObject = _.find(this.items, {'Id': id});
            return foundObject ? "\n" + foundObject.Name + "[IP:" + foundObject.Ip + "]" : null;
          });
          this.confirmModalMsg = `${this.confirmModalMsg} (${names.join(',')})`;
        } else {
          this.confirmModalMsg = `${this.confirmModalMsg} (${this.itemsSelectedCount} vms)`;
        }
        this.confirmButtons = this.confirmStopButtons;
        this.confirmEvent = this.onStopConfirm;
        this.$modal.show('confirm');
      } else {
        console.log('no one VM selected')
      }
    },
    onStopConfirm(data) {
      if (!Object.keys(data).includes('button') ||
          !Object.keys(data).includes('form')) {
        console.log('confirm data excluded button and form fields');
      }
      if (data['button'] === 'stop') {
        this.runStopNodes();
      }
      this.selectedItemsList = [];
    },
    getOptions: function (labelField = null, valueField = null, query, key, currentOptions = [], method = "POST") {
      const options = currentOptions
      axios({
        method,
        url: query,
        headers: this.authHeader(),
        data: []
      }).then(res => {
        if (res === undefined || res === null) {
          return []
        }
        if (res.data.data !== undefined) {
          for (let dataIndex in res.data.data) {
            options.push({
              value: valueField ? res.data.data[dataIndex][valueField] : dataIndex,
              label: labelField ? key.toLowerCase() === 'state' ? this.getStateOptionLabel(res.data.data[dataIndex][labelField]) : res.data.data[dataIndex][labelField] : res.data.data[dataIndex],
            });
          }
        }
      })
      return options;
    },
    loadOptions: async function () {
      await _.forOwn(this.filterOptions, (value, key) => {
        if (value.uri && key !== 'UsedBy') {
          this.filterOptions[key].options = this.getOptions(value.labelField, value.valueField, value.uri, key, this.filterOptions[key].options, value.method ?? 'POST')
        }
      })
      this.loadTypes();
      this.filterPreparing();
      this.filterQuery();
      this.LoadData();
    },
    loadTypes() {
      axios.get(this.apiTypeList, this.authRespConf()).catch(err => {
        console.log(err)
      }).then(res => {
        this.typeList = res.data.data
      })
    },
    modalsHide() {
      console.log("vm modalsHide");
      this.$modal.hide('EditVm');
      this.$modal.hide('modalTextarea');
      this.$modal.hide('DeleteOrDestroyVm');
      this.$modal.hide('confirmVmDestroy');
      this.$modal.hide('confirmVmDeploy');
      this.$modal.hide('VmNewNode');
      this.$modal.hide('confirmItemDelete');
      this.$modal.hide('confirm');
    },
    sortItems() {//start by list logic mixin after data load
      this.items = this.items.sort((a, b) => {
        if (a.State === "CREATED" && b.State !== "CREATED") {
          return -1;
        }
        if (a.State !== "CREATED" && b.State === "CREATED") {
          return 1;
        }
        return 0;
      });
    },
  },
  computed: {
    itemsToDeploySelectedCount() {
      return this.selectedItemsToDeployList.length
    }
    ,
  }
  ,
  watch: {
    '$route': function (val) {
      console.log('vm watch $route', val);
      this.onRouteChange();
      this.filterQuery();
      this.setTitleByFilters();
    },
    selectedItemsList(val) {
      this.itemsSelectedCount = val.length
      this.selectedItemsToDeployList = [];
      if (val.length === 0) {
        this.allSelected = false
      }
      _.map(val, (itemId) => {
        const itemToDeploy = _.find(this.items, {Id: itemId, State: "CREATED"})
        if (itemToDeploy) {
          this.selectedItemsToDeployList.push(itemToDeploy.Id)
        }

      })
    },
    queryFilter: function () {
      this.setTitleByFilters();
    },
  }
  ,
  created: function () {
    this.loadOptions();
    EventBus.$on("vm-update", this.handleUpdate);
    EventBus.$on("vm-rq", this.handleUpdate);
    EventBus.$on("vm-add", this.handleAdd);
    EventBus.$on("vm-delete", this.handleDelete);
    EventBus.$on("vm-del", this.handleDelete);
    EventBus.$on("EscapeKeyDown", this.modalsHide);
    EventBus.$on("UpdateTitle", this.setFilterValuesFromRoute);
    this.setFilterValuesFromRoute();
  },
  beforeDestroy() {
    EventBus.$off("vm-update", this.handleUpdate);
    EventBus.$off("vm-rq", this.handleUpdate);
    EventBus.$off("vm-add", this.handleAdd);
    EventBus.$off("vm-delete", this.handleDelete);
    EventBus.$off("vm-del", this.handleDelete);
    EventBus.$off("EscapeKeyDown", this.modalsHide);
    EventBus.$off("UpdateTitle", this.setFilterValuesFromRoute);
  },
  mounted() {
    this.$nextTick(function () {
      //this.initResizable();
    });
  }
  ,
  updated: function () {
    //this.columnsReset();
    //this.updateResizable();
  }
}
</script>
<style>
.vm-field-comment {
  display: block;
  max-width: 12rem;
  overflow: hidden;
}
.vm-field-iso-icon svg {
  height: 14px;
  margin: 0 5px;
  fill: #606060;
}
</style>